// extracted by mini-css-extract-plugin
module.exports =  {"factoids-list":"_0bc5e8de02--factoids-list--KBKwt","show-more-button":"_0bc5e8de02--show-more-button--ob0VD"};